import * as React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    addHighPrivilegesAccording: {
      backgroundColor: "white",
      color: "black",
      marginLeft: "10px",
      marginRight: "10px",
      textTransform: "none",
      marginTop: "5px"
    },
    subIconButtonDiv: {
      backgroundColor: "white",
      width: "25px",
      height: "25px",
      borderRadius: "100%"
    },
    subPrivilegeAccording: {
      width: "100%",
      marginBottom: "1px"
    },
    AccordionSummary: {
      height: "55px",
      [themes.breakpoints.down('xs')]: {
        height: "150px",
      },
      [themes.breakpoints.between('xs', 'md')]: {
        height: "200px",
      }
    }
  }),
);

export const AccordingList = (props) => {
  const classes = useStyles();
  const [hover, setHover] = React.useState(-1)
  const openPopUp = (e, i, type, defaultVal) => {
    e.stopPropagation();
    props.onOpen(e, i, type, defaultVal)
  }

  const onHover = (id) => {
    setHover(id)
  }
  const removeHover = () => {
    setHover(-1)
  }
  const handleDeleteIconClick = (id,privilege) => {
    console.log(privilege)
    props.onDelete(id,privilege)
  };
  return (
    <div style={{width: "100%"}}>
      {
        props.data.map((child, index) => {
          return (
            <div key={index}>
              <Accordion elevation={0} style={{backgroundColor: `rgba(124, 142, 150, ${props.opacity})`,paddingLeft:'40px'}}
                         TransitionProps={{unmountOnExit: true}} className={classes.subPrivilegeAccording}>
                <AccordionSummary className={classes.AccordionSummary}>
                  <Grid container>
                    <Grid item xs={2} md={2} style={{textAlign: "left", paddingLeft: `${props.padding}px`}}>
                      <Tooltip title={child.name ? child.name : ""} placement="bottom-start" arrow>
                        <Typography
                          style={{marginTop: "12px"}}>{child.name.length > 15 ? child.name.substring(0, 15) + "..." : child.name}</Typography>
                      </Tooltip>
                    </Grid>
                    {
                      child.child.length === 0 ?
                        <Grid item xs={1} md={1}></Grid>
                        :
                        <Grid item xs={1} md={1}>
                          <IconButton>
                            <div className={classes.subIconButtonDiv}><ExpandIcon/></div>
                          </IconButton>
                        </Grid>
                    }

                    <Grid item xs={2} md={2} style={{textAlign: "left"}}>
                      <Tooltip title={child.id ? child.id.toString() : ""} placement="bottom-start" arrow>
                        <Typography
                          style={{marginTop: "12px"}}>{child.id.toString().length > 6 ? child.id.toString().substring(0, 6) + "..." : child.id}</Typography>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={3} md={4} style={{textAlign: "left"}}>
                      <Tooltip title={child.description ? child.description : ""} placement="bottom-start" arrow>
                        <Typography
                          style={{marginTop: "12px"}}>{child.description !== undefined && child.description.length > 40 ? child.description.substring(0, 40) + "..." : child.description}</Typography>
                      </Tooltip>
                    </Grid>

                    <Grid item xs={1} md={3} style={{marginTop: "5px", textAlign: "right"}}>
                      <IconButton data-toggle='tooltip' title='Edit' onClick={(e) => openPopUp(e, child.parentId, "update", {
                        name: child.name,
                        id: child.id,
                        description: child.description,
                        actions: child.actions
                      })}><EditIcon/></IconButton>
                      <IconButton data-toggle='tooltip' title='Delete' onClick={() => handleDeleteIconClick(child.id,child)}><DeleteIcon/></IconButton>
                      <Button
                        onMouseEnter={() => onHover(child.id)}
                        onMouseLeave={() => removeHover()}
                        onClick={(e) => openPopUp(e, child.id, "add-new", undefined)}
                        className={classes.addHighPrivilegesAccording}
                        style={{
                          paddingLeft: hover === child.id ? "10px" : "0px",
                          transition: "0.6s",
                          backgroundColor: hover === child.id ? "white" : "white",
                          minWidth: "24px",
                          height: "24px"
                        }}
                        endIcon={<AddIcon/>}
                      >{hover === child.id ? "Add privilege" : ""}</Button>
                    </Grid>
                  </Grid>
                </AccordionSummary>

                <AccordionDetails style={{
                  backgroundColor: "white",
                  paddingRight: "0px",
                  paddingLeft: "0px",
                  paddingTop: "1px",
                  paddingBottom: "0px"
                }}>
                  <Grid container style={{width: "100%"}}>
                    <AccordingList onDelete={(id,privilege) => props.onDelete(id,privilege)} data={child.child}
                                   onOpen={(e, i, type, defaultVal) => props.onOpen(e, i, type, defaultVal)}
                                   opacity={props.opacity - 0.05}
                                   padding={props.padding > 21 ? props.padding : props.padding + 20}/>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          )
        })
      }
    </div>
  )
}

export const ExpandIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
      <path d="M24 24H0V0h24v24z" fill="none" opacity=".87"/>
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/>
    </svg>
  )
}

export const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15.121" viewBox="0 0 15 15.121">
      <g id="edit" transform="translate(0.5 0.5)">
        <path id="Path_1997" data-name="Path 1997"
              d="M8.5,4H3.444A1.444,1.444,0,0,0,2,5.444V15.556A1.444,1.444,0,0,0,3.444,17H13.556A1.444,1.444,0,0,0,15,15.556V10.5"
              transform="translate(-2 -2.879)" fill="none" stroke="#707070" strokeLinecap="round" strokeLinejoin="round"
              strokeWidth="1.6"/>
        <path id="Path_1998" data-name="Path 1998"
              d="M15.436,2.319A1.5,1.5,0,1,1,17.56,4.443l-6.727,6.727L8,11.879l.708-2.833Z"
              transform="translate(-4 -1.879)" fill="none" stroke="#707070" strokeLinecap="round" strokeLinejoin="round"
              strokeWidth="1.6"/>
      </g>
    </svg>
  )
}

export const DeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.438" height="15.931" color="#F06A6A" viewBox="0 0 14.438 15.931">
      <g id="trash-2" transform="translate(-2.5 -1.5)">
        <path id="Path_13280" data-name="Path 13280" d="M3,6H16.438" transform="translate(0 -1.014)" fill="none"
              stroke="#F06A6A" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6"/>
        <path id="Path_13281" data-name="Path 13281"
              d="M15.452,4.986V15.438a1.493,1.493,0,0,1-1.493,1.493H6.493A1.493,1.493,0,0,1,5,15.438V4.986m2.24,0V3.493A1.493,1.493,0,0,1,8.733,2h2.986a1.493,1.493,0,0,1,1.493,1.493V4.986"
              transform="translate(-0.507)" fill="none" stroke="#F06A6A" strokeLinecap="round" strokeLinejoin="round"
              strokeWidth="1.6"/>
        <line id="Line_503" data-name="Line 503" y2="4.594" transform="translate(8.743 8.891)" fill="none"
              stroke="#F06A6A" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6"/>
        <line id="Line_504" data-name="Line 504" y2="4.594" transform="translate(11.04 8.891)" fill="none"
              stroke="#F06A6A" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6"/>
      </g>
    </svg>
  )
}

export const AddIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
    </svg>
  )
}

export const LockIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" height="20px" viewBox="0 0 256 256" width="20px">
      <g transform="translate(25.6,25.6) scale(0.8,0.8)">
        <g fillOpacity="0.65098" fill="#000032" fillRule="nonzero" stroke="#707070" strokeWidth="1.6" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{mixBlendMode: "normal"}}>
          <g transform="translate(0,-7.68) scale(5.12,5.12)">
            <path d="M25,3c-6.63672,0 -12,5.36328 -12,12v5h-4c-1.64453,0 -3,1.35547 -3,3v24c0,1.64453 1.35547,3 3,3h32c1.64453,0 3,-1.35547 3,-3v-24c0,-1.64453 -1.35547,-3 -3,-3h-4v-5c0,-6.63672 -5.36328,-12 -12,-12zM25,5c5.56641,0 10,4.43359 10,10v5h-20v-5c0,-5.56641 4.43359,-10 10,-10zM9,22h32c0.55469,0 1,0.44531 1,1v24c0,0.55469 -0.44531,1 -1,1h-32c-0.55469,0 -1,-0.44531 -1,-1v-24c0,-0.55469 0.44531,-1 1,-1zM25,30c-1.69922,0 -3,1.30078 -3,3c0,0.89844 0.39844,1.6875 1,2.1875v2.8125c0,1.10156 0.89844,2 2,2c1.10156,0 2,-0.89844 2,-2v-2.8125c0.60156,-0.5 1,-1.28906 1,-2.1875c0,-1.69922 -1.30078,-3 -3,-3z">
              </path>
            </g>
          </g>
        </g>
      </svg>
  )
}

export const OpenLock = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 256 256" width="20px" height="20px">
      <g transform="translate(25.6,25.6) scale(0.8,0.8)">
        <g fillOpacity="0.65098" fill="#000032" fillRule="nonzero" stroke="#707070" strokeWidth="1.6" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{mixBlendMode: "normal"}}>
          <g transform="translate(0,-7.68) scale(5.12,5.12)">
            <path d="M 22.78125 0 C 21.605469 -0.00390625 20.40625 0.164063 19.21875 0.53125 C 12.902344 2.492188 9.289063 9.269531 11.25 15.59375 L 11.25 15.65625 C 11.507813 16.367188 12.199219 18.617188 12.625 20 L 9 20 C 7.355469 20 6 21.355469 6 23 L 6 47 C 6 48.644531 7.355469 50 9 50 L 41 50 C 42.644531 50 44 48.644531 44 47 L 44 23 C 44 21.355469 42.644531 20 41 20 L 14.75 20 C 14.441406 19.007813 13.511719 16.074219 13.125 15 L 13.15625 15 C 11.519531 9.722656 14.5 4.109375 19.78125 2.46875 C 25.050781 0.832031 30.695313 3.796875 32.34375 9.0625 C 32.34375 9.066406 32.34375 9.089844 32.34375 9.09375 C 32.570313 9.886719 33.65625 13.40625 33.65625 13.40625 C 33.746094 13.765625 34.027344 14.050781 34.386719 14.136719 C 34.75 14.226563 35.128906 14.109375 35.375 13.832031 C 35.621094 13.550781 35.695313 13.160156 35.5625 12.8125 C 35.5625 12.8125 34.433594 9.171875 34.25 8.53125 L 34.25 8.5 C 32.78125 3.761719 28.601563 0.542969 23.9375 0.0625 C 23.550781 0.0234375 23.171875 0 22.78125 0 Z M 9 22 L 41 22 C 41.554688 22 42 22.445313 42 23 L 42 47 C 42 47.554688 41.554688 48 41 48 L 9 48 C 8.445313 48 8 47.554688 8 47 L 8 23 C 8 22.445313 8.445313 22 9 22 Z M 25 30 C 23.300781 30 22 31.300781 22 33 C 22 33.898438 22.398438 34.6875 23 35.1875 L 23 38 C 23 39.101563 23.898438 40 25 40 C 26.101563 40 27 39.101563 27 38 L 27 35.1875 C 27.601563 34.6875 28 33.898438 28 33 C 28 31.300781 26.699219 30 25 30 Z"/>
          </g>
        </g>
      </g>
    </svg>

  )
}
